import { Alert } from '@mgmresorts/mgm-ui';
import React, { useCallback, useContext } from 'react';

import { Container } from '../../components/ui/Container';
import { Logo } from '../../components/ui/Logo';
import { PageLayout } from '../../components/ui/PageLayout';
import { WelcomeMGMRewards } from '../../components/ui/WelcomeMGMRewards';
import { useContent } from '../../hooks/useContent';

import { Address } from './Address';
import { BirthdayExtendedInput } from './BirthdayExtendedInput';
import { BirthdayInput } from './BirthdayInput';
import { CTASection } from './CTASection';
import { CanadianOptIn } from './CanadianOptIn';
import { EmailInput } from './EmailInput';
import { FirstName } from './FirstName';
import { LastName } from './LastName';
import { PasswordInput } from './PasswordInput';
import { PhoneNumberInput } from './PhoneNumberInput';
import { PolicyCheckbox } from './PolicyCheckbox';
import { SignUpFormContext } from './SignUpFormContext';
import { SignUpVerification } from './SignUpVerification';
import {
  StyledContainer,
  StyledHeading,
  StyledInfo,
  StyledSubTitle,
  StyledInputContainer,
  StyledAlertContainer,
} from './styles';

export function SignUpForm() {
  const { enrollmentError, showExtendedBirthday, isLoading, isCanadian, showWelcomeMgmRewardsScreen, verificationKid } =
    useContext(SignUpFormContext);
  const { getContentByPath } = useContent();
  const isEnrollmentAnnouncementEnabled = process.env.REACT_APP_ENABLE_ENROLLMENT_ANNOUNCEMENT === 'true';

  const renderFormContent = useCallback(() => {
    return (
      <Container height='auto'>
        <Logo />
        <StyledHeading variant='heading-medium-3' as='h1' testId='page-title'>
          {getContentByPath('accountCreation.title')}
        </StyledHeading>
        {isEnrollmentAnnouncementEnabled && (
          <StyledAlertContainer>
            <Alert
              open
              variant='highlight'
              message={getContentByPath('accountCreation.announcement')}
              testId='signup-info'
              hiddenCloseButton
            />
          </StyledAlertContainer>
        )}
        {!isLoading && enrollmentError && (
          <StyledAlertContainer>
            <Alert open variant='error' message={enrollmentError} testId='signup-error' hiddenCloseButton />
          </StyledAlertContainer>
        )}
        <StyledInfo variant='body-regular-m'>{getContentByPath('accountCreation.info')}</StyledInfo>
        <StyledInputContainer>
          <EmailInput />
        </StyledInputContainer>
        <PasswordInput />
        <div>
          <StyledSubTitle variant='body-medium-l' as='h2' testId='page-sub-title'>
            {getContentByPath('accountCreation.subTitle.guest')}
          </StyledSubTitle>
          <StyledInputContainer>
            <FirstName />
          </StyledInputContainer>
          <StyledInputContainer>
            <LastName />
          </StyledInputContainer>
          <StyledInputContainer>
            {showExtendedBirthday ? <BirthdayExtendedInput /> : <BirthdayInput />}
          </StyledInputContainer>
          <StyledInputContainer>
            <PhoneNumberInput />
          </StyledInputContainer>
        </div>
        <Address />
        {isCanadian && <CanadianOptIn />}
        <PolicyCheckbox />
        <CTASection />
      </Container>
    );
  }, [getContentByPath, isCanadian, enrollmentError, showExtendedBirthday, isLoading, isEnrollmentAnnouncementEnabled]);

  return (
    <StyledContainer>
      <PageLayout
        testId='route-/signup'
        title={getContentByPath('accountCreation.metaTitle')}
        description={getContentByPath('accountCreation.description')}
      >
        {showWelcomeMgmRewardsScreen ? (
          <WelcomeMGMRewards />
        ) : verificationKid ? (
          <SignUpVerification />
        ) : (
          renderFormContent()
        )}
      </PageLayout>
    </StyledContainer>
  );
}

SignUpForm.displayName = 'SignUpForm';
